import React, { useState } from "react";
import axios from "axios";
import "./resetPassword.css";   // ? import CSS

const ResetPassword = () => {
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  // Dummy fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post(
        "https://www.panafricanbookexchange-wandererspath.com/api/auth/reset-password",
        { username, newPassword }
      );

      setMessage(response.data.message || "Password reset successful");

      // ? redirect after success
      setTimeout(() => {
        window.location.href = "/";
      }, 1500);

    } catch (err) {
      const errMsg = err.response?.data?.error || "Error resetting password";
      setMessage(errMsg);
    }
  };

  return (
    <div className="reset-wrapper">
      <div className="reset-card">

        <h2 className="title">Reset Password</h2>

        <form onSubmit={handleReset}>

          <h4 className="subtitle">Identity Verification</h4>

          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e)=>setFirstName(e.target.value)}
          />

          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e)=>setLastName(e.target.value)}
          />

          <input
            type="text"
            placeholder="Enter Username"
            value={username}
            onChange={(e)=>setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Enter New Password"
            value={newPassword}
            onChange={(e)=>setNewPassword(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e)=>setConfirmPassword(e.target.value)}
          />

          <button type="submit">Reset Password</button>
        </form>

        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
};

export default ResetPassword;
